<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card style="padding:20px 50px">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">
        <h4  style="color:var(--medium-blue)"> <i class="mdi mdi-alert"></i> Alerta !</h4> 
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p> 
          Esse animal possui uma baixa de morte ou de desclassificação e data do parto é posterior a data da baixa.
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAlertDeath",
  props:{
    active:Boolean,
  }
}
</script>

<style scoped>
  .close-icon {
    right: 50px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>